import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class ViewApplication {
    
    constructor(private http: HttpClient) { }
    
    viewApplication(url: string, data: any) {
        return this.http.post(url, data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, responseType: 'arraybuffer' });
    }
}